import Vue from "vue";
import VueRouter from "vue-router";

// import SignUp from "../views/SignUp.vue";
// import Home from "../views/Home.vue";
// import Planner from "../views/Planner.vue";
// import JournalEntry from "../views/JournalEntry.vue";
// import Attendance from "../views/Attendance.vue";
// import CustomerSummary from "../views/CustomerSummary.vue";
// import CustomerList from "../views/CustomerList.vue";
// import CustomerDetails from "../views/CustomerDetails.vue";
// import Employeerating from "../views/Employeerating.vue";
// import Appointments from "../views/Appointments.vue"
// import SalesOrders from "../views/SalesOrders"
// import soforcast from "../views/SOforcast"


// const SignUp = () => import(/* webpackChunkName: "SignUp"*/'../views/SignUp.vue')
// const Home = () => import(/* webpackChunkName: "Home" */'../views/Home.vue')
// const Planner = () => import(/* webpackChunkName: "Planner"*/'../views/Planner.vue')
// const JournalEntry = () => import(/* webpackChunkName: "JournalEntry"*/'../views/JournalEntry.vue')
// const Attendance = () => import(/* webpackChunkName: "Attendance"*/'../views/Attendance.vue')
// const CustomerSummary = () => import(/* webpackChunkName: "CustomerSummary"*/'../views/CustomerSummary.vue')
// const CustomerList = () => import(/* webpackChunkName: "CustomerList" */'../views/CustomerList.vue')
// const CustomerDetails = () => import(/* webpackChunkName: "CustomerDetails"*/'../views/CustomerDetails.vue')
// const Employeerating = () => import(/* webpackChunkName: "Employeerating" */'../views/Employeerating.vue')
// const Appointments = () => import(/* webpackChunkName: "Appointments"*/'../views/Appointments.vue')
// const SalesForcastList = () => import(/* webpackChunkName: "SalesForcastList"*/'../views/Salesforcastlist.vue')
// const SalesOrdersList = () => import(/* webpackChunkName: "SalesOrdersList"*/'../views/Salesorderslist.vue')
// const soforcast = () => import(/* webpackChunkName: "soforcast"*/'../views/SOforcast.vue')
// const salesquotationslist = () => import(/* webpackChunkName: "salesquotationslist" */'../views/Salesquotationslist.vue')
// const salesforcast = () => import(/* webpackChunkName: "soforcast"*/'../views/salesforcast.vue')
// const notifications = () => import(/* webpackChunkName: "notification"*/'../views/Notifications.vue')
// const NotificationsAdmin = () => import(/*webpackChunkName:"admin_notification"*/'../views/NotificationsAdmin.vue')
// const summarylist = () => import(/*webpackChunkName:"summarylist"*/'../views/summarylist.vue')
// const Leaves = () => import(/*webpackChunkName:"Leaves"*/'../views/Leaves.vue')
// const lunchSchedule = () => import(/*webpackChunkName:"lunchSchedule"*/'../views/LunchSchedule.vue')
// const despatch = () => import(/*webpackChunkName:"despatch"*/'../views/Despatch.vue')
// const deliveries = () => import(/*webpackChunkName:"deliveries"*/'../views/Deliveries.vue')
// const UsersAdmin = () => import(/*webpackChunkName:"user_management" */'../views/UsersAdmin.vue') 
// const myprofile = () => import (/*webpackChunkName:"user_profile"*/'../views/MyProfile.vue')
// const picklist = () => import (/*webpackChunkName:"picklist"*/'../views/Picklist.vue')
import { store } from "../store";
// import AuthGuard from "./auth-guard";
import AdminGuard from "./admin-guard";
import DynamicAuthGuard from "./dynamic-guard";
import firebase from 'firebase/app';
import 'firebase/auth';
// import configOptions from "../main.js"
Vue.use(VueRouter);
// firebase.initializeApp({
//   apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
//   authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
//   databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
//   projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.VUE_APP_FIREBASE_APP_ID
// });

// const FireAuth = firebase.auth();
const routes = [
  {
    path: "/",
    name: "SignUp",
    // component: SignUp,
    component:() => import(/* webpackChunkName: "SignUp"*/'../views/SignUp.vue'),
    beforeEnter: (to, from, next) => {
      firebase.auth().onAuthStateChanged(user => {
        user ? next("/home") : next()
      });
    }
  },
  {
    path: "/home",
    name: "Home",
    component: () => import(/* webpackChunkName: "Home" */'../views/Home.vue'),
    meta: { requiresAuth: true },
    // component: Home,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/Chat",
    name: "Chat",
    component: () => import(/* webpackChunkName: "Chat" */'../views/ChatInterface.vue'),
    meta: { requiresAuth: true },
    // component: Home,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/planner",
    name: "Planner",
    component: () => import(/* webpackChunkName: "Planner"*/'../views/Planner.vue'),
    // component: Planner,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/brvars",
    name: "Brvars",
    component: () => import(/* webpackChunkName: "Brvars"*/'../views/Brvars.vue'),
    // component: Planner,
    // beforeEnter: AuthGuard,
  },  
  {
    path: "/newbrvar",
    name: "BRVAR Entry",
    component: () => import(/* webpackChunkName: "Brvars"*/'../components/NewBrvar.vue'),
    // component: Planner,
    // beforeEnter: AuthGuard,
  }, 
  {
    path: "/newbrvar1",
    name: "BRVAR Entry",
    component: () => import(/* webpackChunkName: "Brvars"*/'../components/NewBrvar1.vue'),
    // component: Planner,
    // beforeEnter: AuthGuard,
  }, 
  {
    path: "/newLogistics",
    name: "Logistics Requests",
    component: () => import(/* webpackChunkName: "newLogistics"*/'../components/newLogistics.vue'),
    // component: Planner,
    // beforeEnter: AuthGuard,
  }, 
  
  {
    path: "/logisticsDashboard",
    name: "Logistics Dashboard",
    component: () => import(/* webpackChunkName: "logisticsDashboard"*/'../views/LogisticsDasboard.vue'),
    // component: Planner,
    // beforeEnter: AuthGuard,
  }, 
  
  // {
  //   path: "/Appointments",
  //   name: "Appointments",
  //   component: Appointments,
  //   // beforeEnter: AuthGuard,
  // },
  {
    path:"/appointments",
    name:"Appointmenmts",
    component: () => import(/* webpackChunkName: "Appointments"*/'../views/Appointments.vue'),
    beforeEnter: AdminGuard,    
  },
  {
    path: "/journalentry",
    name: "Journal Entry",
    component: () => import(/* webpackChunkName: "JournalEntry"*/'../views/JournalEntry.vue'),

    // component: JournalEntry,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/attendance",
    name: "Attendance",
    component:() => import(/* webpackChunkName: "Attendance"*/'../views/Attendance.vue'),
    // component: Attendance,
    // beforeEnter: AuthGuard,
  },
  // {
  //   path: "/tasks",
  //   name: "Tasks",
  //   component:() => import(/* webpackChunkName: "Attendance"*/'../views/Tasks.vue'),
  //   // component: Attendance,
  //   // beforeEnter: AuthGuard,
  // },
  {
    path: "/customersummary",
    name: "Customer Summary",
    component:() => import(/* webpackChunkName: "CustomerSummary"*/'../views/CustomerSummary.vue'),
    // component: CustomerSummary,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/customerlist",
    name: "Customers",
    component:() => import(/* webpackChunkName: "CustomerList" */'../views/CustomerList.vue'),
    // component: CustomerList,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/customerdetails",
    name: "Customer Details",
    component:() => import(/* webpackChunkName: "CustomerDetails"*/'../views/CustomerDetails.vue'),
    // component: CustomerDetails,
    // beforeEnter: AuthGuard,
  }, 
  {
    path: "/salesforcastslist",
    name: "Sales Forcast",
    // component:() => import(/* webpackChunkName: "SalesForcastList"*/'../views/Salesforcastlist.vue'),
    // component: SalesForcastList,
    // beforeEnter: AuthGuard,
  },  
  {
    path: "/newsaleslead",
    name: "Sales Lead Entry",
    component:() => import(/* webpackChunkName: "SalesLeadNew"*/'../components/SalesLeadNew.vue'),
    // component: SalesForcastList,
    // beforeEnter: AuthGuard,
  }, 
  {
    path: "/leads",
    name: "SalesLeads ",
    component:() => import(/* webpackChunkName: "SalesLeads"*/'../components/SalesLeads.vue'),
    // component: SalesForcastList,
    // beforeEnter: AuthGuard,
  }, 
  {
    path: "/salesleads",
    name: "Sales Leads ",
    component:() => import(/* webpackChunkName: "SalesLeadsView"*/'../views/SalesLeads.vue'),
    // component: SalesForcastList,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/salesorderslist",
    name: "Sales Orders ",
    component: () => import(/* webpackChunkName: "SalesOrdersList"*/'../views/Salesorderslist.vue'),
    // component: SalesOrdersList,
    // beforeEnter: AuthGuard,
  },
  // {
  //   path: "/employeerating",
  //   name: "Employee Rating",  
  //   component: () => import(/* webpackChunkName: "Employeerating" */'../views/Employeerating.vue'),
  //   // component: Employeerating,
  //   // beforeEnter: AuthGuard,
  // },
  {
    path: "/employeeappraisal",
    name: "Employee Appraisal",
    component: () => import(/* webpackChunkName: "Employeerating" */'../views/ApprasieeRating.vue'),
    // beforeEnter: AuthGuard,
  },
  {
    path: "/AppraisalViewer",
    name: "Employee Appraisal 2024",
    // component: () => import(/* webpackChunkName: "AppriasalResult" */'../views/AppriasalResult.vue'),
    // component: Employeerating,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/EditorialViewer",
    name: "Monthly Editorial",
    component: () => import(/* webpackChunkName: "Employeerating" */'../views/EditorialViewer.vue'),
    // component: Employeerating,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/myprofile",
    name: "My Profile ",
    component:() => import (/*webpackChunkName:"user_profile"*/'../views/MyProfile.vue'),

    // component: myprofile,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/mealplanner",
    name: "Meal Planner ",
    component:() => import (/*webpackChunkName:"mealplanner"*/'../components/MealPlanner.vue'),

    // component: myprofile,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/mealplannerw",
    name: "Meal PlannerW ",
    component:() => import (/*webpackChunkName:"mealplannerw"*/'../components/MealPlannerW.vue'),

    // component: myprofile,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/mealplannern",
    name: "Meal PlannerN ",
    component:() => import (/*webpackChunkName:"mealplannern"*/'../components/MealPlannerN.vue'),

    // component: myprofile,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/nmealplanner",
    name: "nMeal Planner ",
    component:() => import (/*webpackChunkName:"nmealplanner"*/'../components/nmealplanner.vue'),

    // component: myprofile,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/salesquotationslist",
    name: "Sales Quotations ",
    component: () => import(/* webpackChunkName: "salesquotationslist" */'../views/Salesquotationslist.vue'),
    // component: salesquotationslist,
    // beforeEnter: AuthGuard,
  },
  // {
  //   path: "/salesforcast",
  //   name: "Sales Forcast ",
  //   component: salesforcast,
  //   // beforeEnter: AuthGuard,
  // },
  {
    path: "/notification",
    name: "Notifications ",
    component: () => import(/* webpackChunkName: "notification"*/'../views/Notifications.vue'),
    meta: { 
      authIdentifier: 'notification_management' ,
      devAccess: ['devAd', 'test',]
    },
    beforeEnter: DynamicAuthGuard,
    // component: notifications,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/file_upload",
    name: "File Upload ",
    component: () => import(/* webpackChunkName: "fileUpload"*/'../views/fileUpload.vue'),
    // component: notifications,
    // beforeEnter: AuthGuard,
    meta: { 
      authIdentifier: 'file_management' ,
      devAccess: ['devAd', 'test',]
    },
    beforeEnter: DynamicAuthGuard,
  },
  {
    path:"/banners",
    name:"Banners",
    component: () => import(/*webpackChunkName:"banners"*/'../views/Banners.vue'),
    // meta: { authIdentifier: 'banner_management' },
    // beforeEnter: DynamicAuthGuard,
    // component: NotificationsAdmin,
    // beforeEnter: AdminGuard,
    meta: { 
      authIdentifier: 'banner_management' ,
      devAccess: ['devAd', 'test',]
    },
    beforeEnter: DynamicAuthGuard,
  },
  {
    path:"/notificationsAdmin",
    name:"Notification Admin Center",
    component: () => import(/*webpackChunkName:"admin_notification"*/'../views/NotificationsAdmin.vue'),
    // component: NotificationsAdmin,
    // beforeEnter: AdminGuard,
    meta: { authIdentifier: 'notification_management' },
    beforeEnter: DynamicAuthGuard,
  },
  {
    path:"/notificationsend",
    name:"Notification Send",
    component: () => import(/*webpackChunkName:"notification_send"*/'../views/NotificationSend.vue'),
    // component: NotificationsAdmin,
    // beforeEnter: AdminGuard,
    meta: { authIdentifier: 'notification_management' },
    beforeEnter: DynamicAuthGuard,
  },
  {
    path:"/deviceregister",
    name:"Register Device",
    component: () => import(/*webpackChunkName:"deviceregisteration"*/'../views/DeviceRegister.vue'),
    // component: NotificationsAdmin,
    // beforeEnter: AdminGuard,
    beforeEnter: DynamicAuthGuard,
  },
  {
    path:"/appsettings",
    name:"App Settings",
    component: () => import(/*webpackChunkName:"appsettings"*/'../components/AppSettings.vue'),
    // component: NotificationsAdmin,
    // beforeEnter: AdminGuard,
    beforeEnter: DynamicAuthGuard,
  },
  {
    path:"/usersAdmin",
    name:"Users Admin  Center",
    component: () => import(/*webpackChunkName:"user_management" */'../views/UsersList.vue') ,
    // component: UsersAdmin,
    // beforeEnter: AdminGuard,
    meta: { 
      authIdentifier: 'user_management' ,
      devAccess: ['devAd', 'test',]
    },
    beforeEnter: DynamicAuthGuard,
  },
  {
    path:"/appraisers",
    name:"Appraisee List",
    // component: () => import(/*webpackChunkName:"appraisee_assign" */'../components/AppraiseeAssign.vue') ,
    component: () => import(/*webpackChunkName:"appraisee_list" */'../views/AppraisersList.vue') ,
    meta: {   authIdentifier: 'appraisee_management'  }, // A constant identifier for authorization
    beforeEnter: DynamicAuthGuard,
    
  },
  {
    path:"/appraiseradd",
    name:"AppraiserAdd",
    // component: () => import(/*webpackChunkName:"appraisee_assign" */'../components/AppraiseeAssign.vue') ,
    component: () => import(/*webpackChunkName:"appraiserAdd" */'../components/AppraiserAdd.vue') ,
    meta: { authIdentifier: 'appraisee_management' },
    beforeEnter: DynamicAuthGuard,
  },  
  {
    path:"/appraisalResults",
    name:"Appraisal Results",
    // component: () => import(/*webpackChunkName:"appraisee_assign" */'../components/AppraiseeAssign.vue') ,
    component: () => import(/*webpackChunkName:"appraisalResult" */'../views/AppraisalResults.vue') ,
    meta: { authIdentifier: 'appraisee_management' },
    beforeEnter: DynamicAuthGuard,
  },
  {
    path:"/appraisalSummary",
    name:"Appraisal Summary",
    // component: () => import(/*webpackChunkName:"appraisee_assign" */'../components/AppraiseeAssign.vue') ,
    component: () => import(/*webpackChunkName:"appraisalSummary" */'../views/AppraisalSummary.vue') ,
    meta: { authIdentifier: 'appraisee_management' },
    beforeEnter: DynamicAuthGuard,
  },
  {
    path:"/appraisalQuestions",
    name:"Appraisal Questions",    
    component: () => import(/*webpackChunkName:"appraisalQuestions" */'../views/AppraisalQuestions.vue'),
    meta: { authIdentifier: 'appraisee_management' },
    beforeEnter: DynamicAuthGuard,
  },
  {
   path:"/summarylist",
   name:"All summary",
   component: () => import(/*webpackChunkName:"summarylist"*/'../views/summarylist.vue'),
  //  component: summarylist,    
  },
  {
    path:"/leaves",
    name:"LeavesRequests ",
    component: () => import(/*webpackChunkName:"leave"*/'../views/leave.vue'),
   //  component: Leaves,    
  },
  {
  path:"/myleaves",
  name:"Leaves ",
  component: () => import(/*webpackChunkName:"Leaves"*/'../views/Leaves.vue'),
  //  component: Leaves,    
  },
  {
    path:"/newleave",
    name:"Leave Request",
    component: () => import(/*webpackChunkName:"NewLeave"*/'../components/NewLeave.vue'),
    //  component: Leaves,    
  },
  {
    path:"/lunchSchedule",
    name:"Lunch Schedule",
    component:() => import(/*webpackChunkName:"lunchSchedule"*/'../views/LunchSchedule.vue'),
    // component: lunchSchedule,     
  },
  {
    path:"/LunchPlanner",
    name:"Lunch Planner",
    component:() => import(/*webpackChunkName:"LunchPlanner"*/'../views/LunchPlanner.vue'),
    // component: lunchSchedule,     
  },
  // {
  //   path:"/mealplanner",
  //   name:"Meal Planner",
  //   component:() => import(/*webpackChunkName:"MealPlanner"*/'../views/MealPlanner.vue'),
  //   // component: lunchSchedule,     
  // },
  {
    path:"/collections",
    name: "Payment Collection",
    component: () => import(/*webpackChunkName:"Collections"*/'../views/Collections.vue'),
    // component: picklist,
  },
  {
    path:"/newcollection",
    name: "Payment Collection Entry", 
    component: () => import(/*webpackChunkName:"NewCollection"*/'../components/NewCollection.vue'),
    // component: picklist,
  },
  {
    path:"/picklist",
    name: "Picklist",
    // component: () => import(/*webpackChunkName:"picklist"*/'../views/Picklist.vue'),
    // component: picklist,
  },
  {
    path:"/despatch",
    name: "Despatch",
    component: () => import(/*webpackChunkName:"despatch"*/'../views/Despatch.vue'),
    // component: despatch,
  },
  {
    path:"/deliveries",
    name:"Deliveries",
    component: () => import(/*webpackChunkName:"deliveries"*/'../views/Deliveries.vue'),
   // component: deliveries,
  },
  {
    path:"/loading",
    name:"Loading",
    component: () => import(/*webpackChunkName:"deliveries"*/'../views/LoadingPermission.vue'),
   // component: deliveries,
  }, 
  {
    path:"/unauthorized",
    name:"UnAuthorized",
    component: () => import(/*webpackChunkName:"deliveries"*/'../views/NotAuthorized.vue'),
   // component: deliveries,
  },
  {
    path:"/comingsoon",
    name:"Coming Soon",
    component: () => import(/*webpackChunkName:"deliveries"*/'../views/ComingSoon.vue'),
   // component: deliveries,
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// Check if the user is logged in
// const isLoggedIn = firebase.auth().currentUser !== null;

router.beforeEach(async (to, from, next) => {
  // const isAuthenticated = store.getters.factsuser && store.getters.authToken;
  const isAuthenticated = await new Promise((resolve) => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        resolve(true); // User is signed in.
      } else {
        resolve(false); // No user is signed in.
      }
    });
  });
  if (to.path !== '/') {
      if (isAuthenticated) {
          // const token = store.getters.authToken;
          // const decodedToken = JSON.parse(atob(token.split('.')[1]));

          // if (from.path!== '/' && decodedToken.exp < Date.now() / 1000) {
          //     try {
          //         await store.dispatch("refreshToken");
          //         await store.dispatch("getScreenName", { screenName: to.name });
          //         next();
          //     } catch (error) {
          //         next('/');
          //         this.$toast.error('Authenication Timeout, Please login again');
          //         // console.error('Error during token refresh:', error);
          //     }
          // } else {
              await store.dispatch("getScreenName", { screenName: to.name });
              next();
          // }
      } else {
          next('/');
      }
  } else {
      if (isAuthenticated) {
          await store.dispatch("getScreenName", { screenName: to.name });
          next('/home');
      } else {
          next();
      }
  }
});

// router.beforeEach(async (to, from, next) => {
//   const isAuthenticated = store.getters.isAuthenticated; // Assumes there's a Vuex getter to check authentication

//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!isAuthenticated) {
//       next('/login');
//     } else {
//       const isTokenExpired = store.getters.isTokenExpired; // Assumes a getter to check token expiry
//       if (isTokenExpired) {
//         try {
//           await store.dispatch("refreshToken"); // Refresh the token if it's expired
//           await store.dispatch("getScreenName", { screenName: to.name }); // Update screen name after refreshing token
//           next();
//         } catch (error) {
//           console.error('Error during token refresh:', error);
//           next('/login'); // Redirect to login if token refresh fails
//         }
//       } else {
//         await store.dispatch("getScreenName", { screenName: to.name }); // Update screen name if token is not expired
//         next();
//       }
//     }
//   } else {
//     if (isAuthenticated) {
//       await store.dispatch("getScreenName", { screenName: to.name }); // Optionally update screen name even for non-auth routes
//     }
//     next(); // Proceed if no auth is required
//   }
// });


// router.beforeEach((to,from,next)=>{
//   if( to.path != '/'){
//      // The user is not logged in, so redirect them to the login page
//     //  next({ path: "/" });
//     //  store.dispatch("signUserOut");
//     if(store.getters.factsuser  &&  store.getters.authToken){
//       // Decoding token to get expiry
//       const token = store.getters.authToken;
//       const decodedToken = JSON.parse(atob(token.split('.')[1]));
      
//       // Checking if token has expired
//       if (decodedToken.exp < Date.now() / 1000) {
//         // If token has expired, attempt to refresh
//         store.dispatch("refreshToken").then(() => {
//           // Proceed if refreshing is successful
//           store.dispatch("getScreenName", {
//             screenName: to.name,
//           });
//           next();
//         })
//         // .catch(() => {        
//         //   // If refreshing fails, redirect to login page          
//         //   next("/");          
//         //   window.alert('Your session has expired, please login again.');
//         //   // window.reload()
//         // });
//       } else {
//         // If token has not expired, continue
//         store.dispatch("getScreenName", {
//           screenName: to.name,
//         });
//         next();
//       }      
//       // console.log('There is a token, resume. (' + to.path + ')');
//       // store.dispatch("getScreenName", {
//       //   screenName: to.name,
//       // });
//       // next();

//     }else {
//       next("/");
//     }
//   }else if(store.getters.factsuser  &&  store.getters.authToken) {
//     // console.log('You\'re on the login page');
//     next("/home");
//   } else{
//     next();
//   }
// })


export default router;
